<template>
    <div class="CoverImage img-responsive relative" :style="style()">
        <slot></slot>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.CoverImage {
    background-color: @color-gray-lightest;
    background-position: center;
    background-size: cover;
}
/*
    .CoverImage--wide {
        min-height: 150px;
        padding-top: 30%;
    }
    .CoverImage--square {
        @media (max-width: @screen-xs-max) {
            padding-top: 60%;
        }
        @media (min-width: @screen-sm-min) {
            padding-top: 80%;
        }
    }
    */
</style>

<script type="text/babel">
export default {
    props: ['src'],

    methods: {
        style() {
            if (this.src) {
                return {
                    'background-image': 'url(' + this.src + ')',
                }
            }
        },
    },
}
</script>
